import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import {
  ReferralRewardDetail,
  ReferralRewardStatus,
  ReferralRewardsResponse,
} from "@customTypes/referralRewards";


export interface ReferralRewardFilters {
  referrerId?: string;
  referrerType?: "doctor" | "recruiter" | "";
  rewardStatus?: ReferralRewardStatus | "";
  search?: string;
  page: number;
  pageSize: number;
}

export const referralRewardQKeys = {
  all: ["dashboard", "referral-rewards"] as const,
  list: (filters: ReferralRewardFilters) =>
    [...referralRewardQKeys.all, "list", filters] as const,
  detail: (rewardEntryId: string) =>
    [...referralRewardQKeys.all, "detail", rewardEntryId] as const,
};

export const useGetReferralRewards = (filters: ReferralRewardFilters) =>
  useQuery<ReferralRewardsResponse>({
    queryKey: referralRewardQKeys.list(filters),
    queryFn: async () => {
      const response = await api.get<ReferralRewardsResponse>(
        "analytics/earnings/referral-rewards",
        {
          params: {
            referrer_id: filters.referrerId || undefined,
            referrer_type: filters.referrerType || undefined,
            reward_status: filters.rewardStatus || undefined,
            search: filters.search || undefined,
            page: filters.page,
            page_size: filters.pageSize,
          },
        }
      );
      return response.data;
    },
    staleTime: 60_000,
  });

export const useGetReferralRewardDetail = (
  rewardEntryId: string,
  enabled: boolean
) =>
  useQuery<ReferralRewardDetail>({
    queryKey: referralRewardQKeys.detail(rewardEntryId),
    queryFn: async () => {
      const response = await api.get<ReferralRewardDetail>(
        `analytics/earnings/referral-rewards/${rewardEntryId}`
      );
      return response.data;
    },
    enabled: enabled && Boolean(rewardEntryId),
    staleTime: 60_000,
  });
